export const cameraView03HullTreatmentImageOptions = {
  legacy: true,
  prefix: 'X4_9_Exterior',
  angle: 'Camera View 03 - Hull treatment',
  staticOptions: {
    Deck: 1,
    TeakOnSideDecks: 1,
    TeakOnCoachroof: 1,
    TeakOnBathingPlatform: 1,
    Boom: 1
  },
  mattes: []
}



// WEBPACK FOOTER //
// ./src/X49/views/CameraView03HullTreatment.js